<template>
  <form-container size="small">
    <h3>Login</h3>

    <loading-indicator v-if="isLoading"/>

    <b-alert v-if="errorMsg" variant="danger" show>{{ errorMsg }}</b-alert>
  </form-container>
</template>

<script>
/**
* Handles a call to the /become endpoint; requires a session token as query parameter:
*   #become?s=r:a54d685e6356fe81004c2fadce0c14b3
* Changes the logged in user to the user represented by the session token.
*/
export default {
  name: 'BecomeScreen',
  data () {
    return {
      isLoading: false,
      errorMsg: null
    }
  },
  mounted () {
    this.become()
  },
  methods: {
    async become () {
      const sessionToken = this.$route.query.s
      if (!sessionToken) {
        this.errorMsg = 'Missing URL parameter: sessionId'
        return
      }

      this.isLoading = true

      try {
        await this.$store.dispatch('become', { sessionToken })
        this.$router.push({name: 'edit'})
      } catch (error) {
        this.errorMsg = error.message
      }

      this.isLoading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BecomeScreen.vue